<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col>
        <div class="form-group">
          <label
                  for="excmrelationuserdata_userData"
                  class="form-control-label">{{$t('views.excmrelationuserdata.form.userData')}}:</label>
          <div class="form-group">
            <fg-input>
              <el-select
                class="select-default"
                :placeholder="$t('views.excmrelationuserdata.form.userData')"
                filterable
                v-model="item.userData">
                <el-option v-for="option in userDataOptions"
                           class="select-default"
                           :value="option['@id']"
                           :label="option.name + ' ' + option.surname"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
          <div
                  v-if="isInvalid('userData')"
                  class="invalid-feedback">{{ violations.userData }}</div>
        </div>
      </b-col>
    </b-row>

    <button type="submit" class="btn btn-success">{{ $t('buttons.submit') }}</button>
    <b-btn @click="closeModal()" variant="danger">{{ $t('buttons.cancel') }}</b-btn>
  </form>
</template>

<script>
export default {
  props: {
    relation: {
      type: Object,
      default: null
    },

    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      userDataOptions: []
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  created () {
    if (this.relation) {
      this.item.relation = this.relation['@id']
    }
    this.getUserDatas()
  },

  methods: {
    closeModal () {
      this.$store.state.modals.excmrelationuserdata.create.close = 1
    },

    getUserDatas () {
      let params = {
        'pagination': false,
        'isCompany': 0,
        'state': 1,
        'idClientType': [5, 4, 3, 8]
      }
      this.userDataOptions = []
      this.$http.get('api/user_datas', {
        params
      })
        .then(response => {
          this.userDataOptions = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },

    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
